import { Component, OnInit, ViewChild } from '@angular/core';
import { LicencasService } from '../service/licencas.service';
import { ClientesService } from '../service/clientes.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { AlertService } from '../service/alert.service';
import { Router } from '@angular/router';
import { VerificarPermissoes } from '../model/verificarPermissoes.model';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Licenca } from '../model/licenca.model';
import { BuscaService } from '../service/busca.service';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-licenca',
  templateUrl: './licenca.component.html',
  styleUrls: ['./licenca.component.css']
})
export class LicencaComponent implements OnInit {

  public carregando: boolean = true;
  public licencas: any = [];
  public usinas: any = [];
  public colunas: any = [];
  public licencasAdquiridas: any = [];
  public licencaFiltrada: string = '';
  public usinaFiltrada: string = localStorage.getItem('cliente')!;
  public chavesParaPegarOsDadosDaLicenca: any = [];
  public exibirMensagemDeCopiadoParaAreaDeTranferencia = false;
  public page = 1;
  public count = 0;
  public pageSize = 1;
  public qntLicencasAdquiridas: any = [];
  public statusSelecionado = '';
  licencasFormatadas: any[] = [];
  public colunasPadrao: string[] = [ 
    'vc_nota_fiscal',
    'vc_os_manutencao',
    'vc_proposta',
    'ts_ativacao',
    'ts_expiracao',
    'ts_criado_em',
    'vc_nome',
    'vc_status',
    'vc_alvo_tecnico_cancelamento',
    'vc_token',
    'opcoes'
  ] 
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  public displayedColumns: string[] = [
    'vc_nota_fiscal',
    'vc_os_manutencao',
    'vc_proposta',
    'ts_ativacao',
    'ts_expiracao',
    'ts_criado_em',
    'vc_nome',
    'vc_status',
    'vc_alvo_tecnico_cancelamento',
    'vc_token',
    'opcoes'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
  @ViewChild(MatSort) sort: MatSort | null = null;

  constructor(
    private licencaService: LicencasService,
    private serviceClientes: ClientesService,
    private alertService: AlertService,
    private router: Router,
    private buscaService: BuscaService
  ) { }

  ngOnInit(): void {
    this.listarLicenca();
    this.listarClientes();
    this.dataSourcePesquisa();
  }

  listarLicenca() {
    this.licencaService.listarLicencaComCampos().subscribe((licencasResposta: any) => {
      this.licencas = licencasResposta;
      this.licencaFiltrada = licencasResposta[0].sr_id;
      this.listarLicencasAdquiridas();
      this.listarQntDeAcoesDasLicencasAdquiridas();
    });
  }

  listarClientes() {
    this.serviceClientes.listarServiceClientes().subscribe((resp) => {
      this.usinas = resp;
    });
  }

  limparDadosTabela(): void {
    this.licencasAdquiridas = [];
    this.chavesParaPegarOsDadosDaLicenca = [];
    this.colunas = [];
    this.statusSelecionado = '';
    this.count = 0;
    this.pageSize = 0;
    this.dataSource.data = [];
    this.displayedColumns = this.colunasPadrao
  }

  listarLicencasFiltradas(): void {
    this.carregando = true;
    const params = this.parametroSolicitacao(this.page);
    this.licencaService.listarLicencaAdquiridaPorStatusComClienteComDadosUsuariosPaginadoOrdenadoPeloId(params, this.licencaFiltrada, this.statusSelecionado, this.usinaFiltrada).subscribe((licencasResposta: any) => {
      this.setarVariaveisParaPopularATabela(licencasResposta)
    });
  }

  listarLicencasAdquiridas(): void {
    this.carregando = true;
    this.limparDadosTabela();
    const params = this.parametroSolicitacao(this.page);
    this.licencaService.listarLicencaAdquiridaPorIdOuIdEClienteComDadosUsuariosOrdenadoPeloId(params, this.usinaFiltrada, this.licencaFiltrada).subscribe((licencasResposta: any) => {
      this.setarVariaveisParaPopularATabela(licencasResposta)
    });
  }

  definirColunasDaTabela(): void {
    this.chavesParaPegarOsDadosDaLicenca = Object.keys(this.dataSource.data[0].js_informacoes_licenca);
    this.colunas = this.chavesParaPegarOsDadosDaLicenca;
    this.displayedColumns = [...this.colunas, ...this.colunasPadrao];
  }

  formatarNomeColuna(nomeColuna: string): string {
    return nomeColuna.replace(/_/g, ' ');
  }

  copiarTexto(texto: string) {
    const elementoTemporario = document.createElement('textarea');
    elementoTemporario.value = texto;
    document.body.appendChild(elementoTemporario);
    elementoTemporario.select();
    document.execCommand('copy');
    document.body.removeChild(elementoTemporario);
    this.exibirMensagemDeCopiadoParaAreaDeTranferencia = true;
    setTimeout(() => {
      this.exibirMensagemDeCopiadoParaAreaDeTranferencia = false;
    }, 3000);
  }

  alternarOcultarTexto(licencaAdquirida: any) {
    licencaAdquirida.ocultarTexto = !licencaAdquirida.ocultarTexto;
  }

  mostrarInformacoes(licencaAdquirida: any) {
    let descricao: string = licencaAdquirida.vc_descricao_cancelamento != null ? `<p style="font-size:11pt"><b>Motivo do cancelamento</b>: ${licencaAdquirida.vc_descricao_cancelamento}</p>` : "";
    Swal.fire({
      title: "Informações",
      html: `
      ${descricao}
      <p style="font-size:11pt;margin:left" ><b>Alvo tecnico cancelamento</b>: ${licencaAdquirida.vc_alvo_tecnico_cancelamento}</p>
      `,
      inputAttributes: {
        autocapitalize: "off",
        required: 'true'
      }
    })
  }

  cancelarLicenca(licencaAdquirida: any) {
    Swal.fire({
      title: 'Você está cancelando o token ' + licencaAdquirida.vc_token,
      text: 'Cancelar a licença não bloqueará o uso do equipamento. Uma vez cancelado não será possível reverter a ação.',
      confirmButtonText: 'Confirmar',
      confirmButtonColor: '#00AA5B',
      allowOutsideClick: false,
      cancelButtonColor: '#EF4C3A',
      showCancelButton: true
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Preencha os Campos:",
          html: `
            <label for="report-number">Número do relatório:</label>
            <input id="report-number" placeholder:"Número do relatório do alvo de cancelamento no cliente:" class="swal2-input" type="text" required>
            <label for="cancellation-reason">Motivo do cancelamento:</label>
            <textarea  style="display:block;margin:auto;height:250px" cols="24" rows="15" id="cancellation-reason" class="swal2-input" value="aaaaaaa" type="text" required></textarea>
          `,
          inputAttributes: {
            autocapitalize: "off",
            required: 'true'
          },
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          confirmButtonColor: '#00AA5B',
          cancelButtonColor: '#EF4C3A',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            const alvoTecnico: any = (document.getElementById('report-number') as HTMLInputElement)!.value;
            const descricao = (document.getElementById('cancellation-reason') as HTMLInputElement)!.value;;

            if (!alvoTecnico || !descricao) {
              Swal.showValidationMessage('Por favor, preencha todos os campos!');
            }
            return { alvoTecnico, descricao };

          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.licencaService.cancelarLicencaAdquirirda(licencaAdquirida.sr_id, result.value).subscribe((licencaAdquiridaCancelada: any) => {
              this.listarLicencasAdquiridas();
              this.listarQntDeAcoesDasLicencasAdquiridas();
              this.alertService.success();
            },
              (erro) => {
                this.alertService.error("Não foi possivel cancelar licença");
              })
          }
        });
      }
    })
  }

  renovarOuTrocarLicencaOuEditar(licencaAdquirida: any, tipoDeAlteracao: any): void {
    licencaAdquirida.js_informacoes_licenca = JSON.stringify(licencaAdquirida.js_informacoes_licenca);
    licencaAdquirida.usuario = JSON.stringify(licencaAdquirida.usuario);
    this.router.navigate(['configuracao/licencas/alterarLicencaAdquirida', tipoDeAlteracao], {
      queryParams: licencaAdquirida
    });
  }

  mudarPagina(event: number): void {
    this.page = event;
    if (this.statusSelecionado === '') {
      this.listarLicencasAdquiridas();
    } else {
      this.listarLicencasFiltradas();
    }
  }

  parametroSolicitacao(page: number): any {
    let params: any = {};
    if (page) {
      params[`page`] = page;
    }
    return params;
  }

  verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  setarVariaveisParaPopularATabela(licencasResposta: any): void {
    if (licencasResposta.length > 0) {
      licencasResposta.forEach((licencaAdquirida: any) => {
        licencaAdquirida.js_informacoes_licenca = JSON.parse(licencaAdquirida.js_informacoes_licenca);
        licencaAdquirida.ocultarTexto = true;
      });
      this.dataSource.data = licencasResposta;
      this.dataSource.paginator = this.paginator;
      this.pageSize = this.licencasAdquiridas.length;
      this.count = licencasResposta.length;
      this.definirColunasDaTabela();
    }
    this.carregando = false;
  }

  listarQntDeAcoesDasLicencasAdquiridas() {
    this.licencaService.listarQntDeLicencasAdquiridasAcoes(this.licencaFiltrada, this.usinaFiltrada).subscribe((qntLicencasAdquiridas: any) => {
      qntLicencasAdquiridas.forEach((qntLicenca: any) => {
        qntLicenca.click = false;
      });
      this.qntLicencasAdquiridas = qntLicencasAdquiridas
    })
  }

  mudancaDeFiltro(): void {
    this.carregando = true; 
    this.limparDadosTabela(); 
    this.listarLicencasAdquiridas(); 
    this.listarQntDeAcoesDasLicencasAdquiridas(); 
  }
  
  filtrarPorStatus(status: any): void {
    this.page = 1;
    if (this.statusSelecionado == status) {
      this.statusSelecionado = '';
      this.listarLicencasAdquiridas();
    } else {
      this.statusSelecionado = status;
      this.listarLicencasFiltradas();
    }
  }

  gerarTokensPDF(): void {
    const doc = new jsPDF();
    this.licencasFormatadas = [];
    let mensagemErro: string = '';

    if (!this.usinaFiltrada) {
      mensagemErro = 'É necessário filtrar uma usina para gerar o documento em PDF';
    } else if (!this.licencaFiltrada) {
      mensagemErro = 'É necessário filtrar um tipo de licença para gerar o documento em PDF';
    }

    if (mensagemErro) {
      this.dialogPersonalizado('error', 'Não foi possivel gerar o documento em PDF', mensagemErro, '#EF4C3A', 'Fechar');
    } else {
      this.licencaService.listarLicencaAdquiridaPorClienteComDadosUsuariosOrdenadoPeloId(this.usinaFiltrada, this.licencaFiltrada).subscribe((licencasResposta: any) => {
        licencasResposta.forEach((element: any) => {
          if (element.vc_status == 'ATIVO') {
            let dataAtivacao = new Date(element.ts_ativacao).toLocaleDateString('pt-BR');
            let informacoesLicenca = JSON.parse(element.js_informacoes_licenca);
            let identificador: string = element.vc_nota_fiscal ? element.vc_nota_fiscal : (element.vc_os_manutencao ? element.vc_os_manutencao : '-');
            let tipoIdentificador: string = element.vc_nota_fiscal ? 'Nota Fiscal' : (element.vc_os_manutencao ? 'Ordem Serviço' : 'Demo');

            this.licencasFormatadas.push([
              informacoesLicenca.Numero_do_hardware,
              tipoIdentificador,
              identificador,
              dataAtivacao,
              element.vc_token
            ]);
          }
        });

        autoTable(doc, {
          headStyles: { fillColor: [2, 176, 86] },
          head: [['Número de hardware', 'Tipo', 'Identificador', 'Data de ativação', 'Token']],
          body: this.licencasFormatadas
        });

        doc.save('licencas.pdf');
      });
    }
  }

  dialogPersonalizado(icon: 'error' | 'info' | 'question' | 'success' | 'warning', title: string, text: string, buttonColor: string, buttonText: string): void {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      confirmButtonColor: buttonColor,
      confirmButtonText: buttonText
    })
  }

  dataSourcePesquisa(): void {
    this.dataSource.filterPredicate = (data: Licenca, filter: string) => {
      let nome = data.vc_nome ? this.buscaService.removerAcentos(data.vc_nome).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      let nota_fiscal = data.vc_nota_fiscal ? this.buscaService.removerAcentos(data.vc_nota_fiscal).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      let ts_ativacao = data.ts_ativacao ? this.buscaService.removerAcentos(formatDate(data.ts_ativacao, 'dd/MM/yyyy', 'en-US')).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
      let ts_expiracao = data.ts_expiracao ? this.buscaService.removerAcentos(formatDate(data.ts_expiracao, 'dd/MM/yyyy', 'en-US')).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
      let ts_criado_em = data.ts_criado_em ? this.buscaService.removerAcentos(formatDate(data.ts_criado_em, 'dd/MM/yyyy', 'en-US')).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;


      let numero_do_hardware = data.js_informacoes_licenca.Numero_do_hardware ? this.buscaService.removerAcentos(data.js_informacoes_licenca.Numero_do_hardware).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
      let numero_de_serie = data.js_informacoes_licenca.Numero_de_serie ? this.buscaService.removerAcentos(data.js_informacoes_licenca.Numero_de_serie).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      let vc_alvo_tecnico_cancelamento = data.vc_alvo_tecnico_cancelamento ? this.buscaService.removerAcentos(data.vc_alvo_tecnico_cancelamento).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      let vc_status = data.vc_status ? this.buscaService.removerAcentos(data.vc_status).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      let vc_proposta = data.vc_proposta ? this.buscaService.removerAcentos(data.vc_proposta).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
      let usuario = data.usuario.vc_nome ? this.buscaService.removerAcentos(data.usuario.vc_nome).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase())) : false;
    
      return nome || usuario || nota_fiscal || ts_ativacao || vc_alvo_tecnico_cancelamento || vc_status || vc_proposta || numero_do_hardware || numero_de_serie || ts_expiracao || ts_criado_em;
    }
    
  }
  
  
  pesquisarLicenca(event: Event): void {
    const pesquisa = (event.target as HTMLInputElement).value;
    this.dataSource.filter = pesquisa;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
